module.exports = __webpack_public_path__ + "files/1489a13d56f485e88bdcaf734b3a5e7e.png";